import { useEffect } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { C, fBody } from '../../Shared/Brand'

// Landing point for the Bitnix admin panel's "Login as User (Xperia)" button.
// Xperia Capital shares Bittronexa's UserModel/JWT_SECRET but is a separate
// deployed origin, so the impersonation token can't travel via localStorage
// like it does inside the single bittronexa-frontend app — it arrives as a
// one-time URL param instead, gets persisted here, then the URL is replaced
// so it doesn't linger in browser history.
export default function AdminHandoff() {
    const navigate = useNavigate()
    const [searchParams] = useSearchParams()

    useEffect(() => {
        const token = searchParams.get('token')
        if (!token) {
            navigate('/login', { replace: true })
            return
        }

        localStorage.setItem('token', token)
        localStorage.setItem('xp_impersonating', 'true')
        localStorage.setItem('xp_impersonated_username', searchParams.get('username') || '')

        const adminReturnUrl = searchParams.get('adminReturnUrl')
        if (adminReturnUrl) {
            localStorage.setItem('xp_admin_return_url', adminReturnUrl)
        } else {
            localStorage.removeItem('xp_admin_return_url')
        }

        navigate('/user/bot', { replace: true })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <div style={{
            minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
            background: C.dark, color: C.ltx2, fontFamily: fBody, fontSize: 14,
        }}>
            Signing you in…
        </div>
    )
}
